import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import Input from '../../../../../components/input';

class Password extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        value: PropTypes.string,
        error: PropTypes.bool,
        errorMessage: PropTypes.any,
    };

    state = {
        strongLevel: 0,
    };

    // 密码健壮度
    checkStrong = v => {
        let hasNum = false;
        let hasLower = false;
        let hasUpper = false;
        let hasSpecial = false;
        let sum = 0;

        hasNum = !!/\d+/.test(v);
        hasLower = !!/[a-z]+/.test(v);
        hasUpper = !!/[A-Z]+/.test(v);
        hasSpecial = !!/[^\s\da-zA-Z]+/.test(v);
        sum = hasNum + hasLower + hasUpper + hasSpecial;

        if (sum === 1) {
            this.setState({
                strongLevel: 0,
            });
        } else if (sum === 2) {
            this.setState({
                strongLevel: 1,
            });
        } else if (sum >= 3) {
            this.setState({
                strongLevel: 2,
            });
        }
    };

    onChange = value => {
        this.checkStrong(value);
        this.props.onChange(value);
    };

    render() {
        const { onBlur, value, error, errorMessage } = this.props;
        const config = {
            onChange: this.onChange,
            onBlur,
            value,
            error,
            errorMessage,
        };
        const { strongLevel } = this.state;

        const renderStrong = level => {
            let res = (
                <div className={styles.checkStrong}>
                    密码强度：<span className={styles.rde}>低</span>
                    <br />
                    <img
                        src="//x0.ifengimg.com/ucms/2020_45/23095DB06D9B6E2A95767E1D93D488FE179566BB_w44_h4.gif"
                        width="44"
                        height="4"
                    />
                </div>
            );

            switch (level) {
                case 0:
                    break;
                case 1:
                    res = (
                        <div className={styles.checkStrong}>
                            密码强度：<span className={styles.rde}>中</span>
                            <br />
                            <img
                                src="//x0.ifengimg.com/ucms/2020_45/23095DB06D9B6E2A95767E1D93D488FE179566BB_w44_h4.gif"
                                width="44"
                                height="4"
                            />
                            <img
                                src="https://x0.ifengimg.com/ucms/2020_45/7270205DA436386B8F311A1AFF8B873DB2790948_w44_h4.gif"
                                width="44"
                                height="4"
                            />
                        </div>
                    );
                    break;
                case 2:
                    res = (
                        <div className={styles.checkStrong}>
                            密码强度：<span className={styles.rde}>高</span>
                            <br />
                            <img
                                src="//x0.ifengimg.com/ucms/2020_45/23095DB06D9B6E2A95767E1D93D488FE179566BB_w44_h4.gif"
                                width="44"
                                height="4"
                            />
                            <img
                                src="https://x0.ifengimg.com/ucms/2020_45/7270205DA436386B8F311A1AFF8B873DB2790948_w44_h4.gif"
                                width="44"
                                height="4"
                            />
                            <img
                                src="https://x0.ifengimg.com/ucms/2020_45/174D1136F29C93E82FA27B94344468C47B3F0775_w44_h4.gif"
                                width="44"
                                height="4"
                            />
                        </div>
                    );
                    break;

                default:
                    break;
            }

            return res;
        };

        return (
            <React.Fragment>
                <div className={styles.password}>
                    <label>
                        <span className={styles.label}>密码</span>
                        <div className={styles.input}>
                            <Input type={'password'} {...config} placeholder={'请输入密码'} />
                        </div>
                    </label>
                    {error ? <div className={styles.error}>{errorMessage}</div> : null}
                    {error || !value ? null : renderStrong(strongLevel)}
                </div>
                <p className={styles.tip}>8-20位字符，至少包括大写、小写、数字、特殊字符中三种</p>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Password);
